import axios from "axios";

// The server questions a purchase rate far outside the material's own history
// (a kilo price typed per tonne is a thousandfold) with a 409 carrying
// details.code = "unusual_rate". Returns the material's usual rate when that is
// the error, and null for anything else, so the caller falls back to its plain
// error message. Shared by every form that records a priced purchase: a form
// that shows the question but cannot answer it leaves the operator stuck.
export function extractUnusualRate(err: unknown): number | null {
  if (!axios.isAxiosError(err) || err.response?.status !== 409) return null;
  const details = (err.response.data as { details?: { code?: string; typical_rate?: number } } | undefined)?.details;
  if (details?.code !== "unusual_rate") return null;
  return typeof details.typical_rate === "number" ? details.typical_rate : 0;
}
